import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { GetStockLocationsInput, PaginationInput } from '@/gql/graphql';
import { PAGINATION_ARG_DEFAULTS } from '@payaca/shared-isomorphic/constants/graphql-pagination';

import stockLocationKeys from './keyFactory';

const GetStockLocations = graphql(`
  query StockLocations(
    $input: GetStockLocationsInput
    $pagination: PaginationInput!
  ) {
    stockLocations(input: $input, pagination: $pagination) {
      items {
        id
        name
        notes
        archivedAt
        address {
          id
          line1
          line2
          city
          administrativeArea
          postalCode
          country
        }
      }
      totalCount
      offset
      limit
    }
  }
`);

const useGetStockLocations = (
  input: GetStockLocationsInput = {},
  pagination: PaginationInput = PAGINATION_ARG_DEFAULTS,
  enabled: boolean = true
) => {
  const { data, ...rest } = useQuery({
    queryKey: stockLocationKeys.list(input, pagination),
    queryFn: () => gqlClient.request(GetStockLocations, { input, pagination }),
    enabled,
  });

  return { stockLocations: data?.stockLocations, ...rest };
};

export default useGetStockLocations;
